import React, { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Search, Menu, X } from "lucide-react";

const navLinks = [
  { to: "/recettes", label: "Recettes" },
  { to: "/cuisines-du-monde", label: "Cuisines du monde" },
  { to: "/guides", label: "Guides" },
  { to: "/a-propos", label: "À propos" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const navigate = useNavigate();

  const onSearch = (e) => {
    e.preventDefault();
    if (q.trim()) {
      navigate(`/recettes?q=${encodeURIComponent(q.trim())}`);
      setOpen(false);
    }
  };

  return (
    <header className="glass-nav sticky top-0 z-50" data-testid="site-header">
      <div className="container-x flex items-center justify-between h-16 md:h-20">
        <Link to="/" className="flex items-center gap-2" data-testid="logo-link">
          <span className="font-serif text-2xl md:text-3xl tracking-tight text-[hsl(var(--text-primary))]">
            Recette<span className="text-[hsl(var(--brand-primary))]">·</span>Diabete
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `text-sm tracking-wide transition-colors ${
                  isActive
                    ? "text-[hsl(var(--brand-primary))]"
                    : "text-[hsl(var(--text-primary))] hover:text-[hsl(var(--brand-primary))]"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <form onSubmit={onSearch} className="relative" data-testid="search-form">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[hsl(var(--text-muted))]" strokeWidth={1.5} />
            <input
              data-testid="search-input"
              type="text"
              placeholder="Rechercher une recette…"
              value={q}
              onChange={(e) => setQ(e.target.value)}
              className="pl-9 pr-4 py-2 text-sm bg-white/60 border border-[hsl(var(--border-light))] rounded-sm focus:outline-none focus:border-[hsl(var(--brand-primary))] w-64"
            />
          </form>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden p-2"
          onClick={() => setOpen(!open)}
          aria-label="Menu"
        >
          {open ? <X strokeWidth={1.5} /> : <Menu strokeWidth={1.5} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-[hsl(var(--border-light))] bg-white/90 backdrop-blur">
          <div className="container-x py-4 flex flex-col gap-3">
            {navLinks.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                onClick={() => setOpen(false)}
                className="text-base text-[hsl(var(--text-primary))]"
                data-testid={`mobile-nav-${l.label.toLowerCase()}`}
              >
                {l.label}
              </Link>
            ))}
            <form onSubmit={onSearch} className="relative mt-2">
              <input
                data-testid="mobile-search-input"
                type="text"
                placeholder="Rechercher…"
                value={q}
                onChange={(e) => setQ(e.target.value)}
                className="w-full pl-3 pr-4 py-2 text-sm border border-[hsl(var(--border-light))] rounded-sm"
              />
            </form>
          </div>
        </div>
      )}
    </header>
  );
}
